import { useState, useEffect } from 'react'
import { db } from '../firebase/config'

/**
 * Eén inzicht (QuestionInsights), live, op zijn eigen ID.
 *
 * Drie toestanden apart: nog niet geladen, niet kunnen lezen, en echt niet
 * gevonden. 'Dit inzicht bestaat niet' is een bewering en mag pas na een
 * gelukte read.
 * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
 * AI-CONTEXT: See docs/pitfalls.md#database-firestore-silent-listener-failure
 *
 * @param {string} insightId - '' = nog niet bekend, dan geen listener
 * @returns {{insight: (object|null), loading: boolean, loaded: boolean, error: (Error|null)}}
 */
const useInsight = (insightId) => {
    const [insight, setInsight] = useState(/** @type {object|null} */(null))
    const [loaded, setLoaded] = useState(false)
    const [error, setError] = useState(/** @type {Error|null} */(null))

    useEffect(() => {
        if (!insightId) return undefined
        setLoaded(false)
        setError(null)
        const unsub = db.collection('QuestionInsights')
            .where('ID', '==', insightId)
            .onSnapshot(
                (snap) => {
                    const doc = snap.docs.map((d) => ({ docid: d.id, ...d.data() })).find((d) => d.Deleted !== true) || null
                    setInsight(doc)
                    setLoaded(true)
                },
                (err) => {
                    console.error('useInsight:', insightId, err)
                    setError(err)
                    setInsight(null)
                    setLoaded(false)
                },
            )
        return () => unsub()
    }, [insightId])

    return { insight, loading: !loaded && error === null, loaded, error }
}

export default useInsight
